import { isValidPhoneNumber as libIsValidPhoneNumber } from 'libphonenumber-js';
import { parsePhoneNumber } from './phone-number';

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^\S+@\S+\.\S+$/;
  return emailRegex.test(email);
};

export function isValidPhoneNumber(phoneNumber: string): boolean {
  phoneNumber = parsePhoneNumber(phoneNumber);
  const uaeSixteenDigitPattern = /^\+971\d{12}$/;
  return libIsValidPhoneNumber(phoneNumber) || uaeSixteenDigitPattern.test(phoneNumber);
}
